// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// AUT-6431: the viewer shows ONLY the selected order's boundary KML. getFeatureCollection
// merges every order's boundary (the dashboard/2D-viewer behavior); here the collection is
// filtered to the sidebar's selected order before it reaches the map, so a multi-order project
// draws one boundary instead of N identical rectangles. The sidebar's "KML Boundary" checkbox
// toggles the layer on and off.

interface BoundaryFeature {
  // GeoJSON declares properties as object-or-null; both read as "no stamps".
  properties?: ({ orderId?: string } & Record<string, unknown>) | null;
}

interface BoundaryCollection {
  type: string;
  features: BoundaryFeature[];
}

export const KML_BOUNDARY_COLOR = '#5bafad';

// Only the selected order's boundary survives; with no selection yet (viewer initializing) or
// for features missing their orderId stamp, nothing is shown - the layer simply stays off
// until the sidebar's selection settles a moment later.
// Generic so callers keep their own FeatureCollection typing.
export const selectOrderBoundaries = <T extends BoundaryCollection>(
  collection: T,
  selectedOrderId?: string | null,
): T => ({
    ...collection,
    features: selectedOrderId
      ? (collection.features || []).filter((feature) => feature.properties?.orderId === selectedOrderId)
      : [],
  } as T);

// Autocast renderer object for GeoJSONLayer - the selected order's boundary in the viewer's
// long-standing bold teal.
export const boundaryRenderer = {
  type: 'simple',
  symbol: {
    type: 'simple-fill',
    color: [0, 0, 0, 0],
    outline: {
      color: KML_BOUNDARY_COLOR,
      width: 2,
    },
  },
};

export default boundaryRenderer;
